import { BadgeLabel } from '@yleisradio/areena-types';
import React from 'react';

import styles from './FavoritesBadge.module.scss';

interface ItemProps {
  favoritesBadge: BadgeLabel;
}
export const FavoritesBadge: React.FunctionComponent<ItemProps> = ({
  favoritesBadge,
}) => {
  return <div className={styles.badge}>{favoritesBadge.formatted}</div>;
};
